import { createSelector } from 'reselect';

const selectMain = (state) => state.main;

// DIAGRAM DB ENGINE
export const selectDiagramDbEngine = createSelector(
    [selectMain],
    (main) => main.diagramDbEngine
);

// DIAGRAM DETAILS
export const selectDiagramDetails = createSelector(
    [selectMain],
    (main) => main.diagramDetails
);

// DIAGRAM ERRORS
export const selectIsDiagramNotFound = createSelector(
    [selectMain],
    (main) => main.isDiagramNotFound
);
export const selectIsQuickShareLinkInvalid = createSelector(
    [selectMain],
    (main) => main.isQuickShareLinkInvalid
);


// MODAL DIAGRAM RENAME
export const selectIsModalDiagramRenameEnabled = createSelector(
    [selectMain],
    (main) => main.isModalDiagramRenameEnabled
);
export const selectModalDiagramRenameData = createSelector(
    [selectMain],
    (main) => main.modalDiagramRenameData
);

// MODAL DIAGRAM DETAILS
export const selectIsModalDiagramDetailsEnabled = createSelector(
    [selectMain],
    (main) => main.isModalDiagramDetailsEnabled
);
export const selectModalDiagramDetailsData = createSelector(
    [selectMain],
    (main) => main.modalDiagramDetailsData
);

// MODAL FEEDBACK / SUPPORT
export const selectIsModalSupportEnabled = createSelector(
    [selectMain],
    (main) => main.isModalSupportEnabled
);
export const selectModalSupportData = createSelector(
    [selectMain],
    (main) => main.modalSupportData
);
export const selectFeedbackSentStatus = createSelector(
    [selectMain],
    (main) => main.feedbackSentStatus
);

// MODAL FEEDBACK THANKS
export const selectIsModalFeedbackThanksEnabled = createSelector(
    [selectMain],
    (main) => main.isModalFeedbackThanksEnabled
);
export const selectModalFeedbackThanksData = createSelector(
    [selectMain],
    (main) => main.modalFeedbackThanksData
);

// MODAL DIAGRAM QUICK SHARE
export const selectIsModalDiagramQuickShareEnabled = createSelector(
    [selectMain],
    (main) => main.isModalDiagramQuickShareEnabled
);
export const selectModalDiagramQuickShareData = createSelector(
    [selectMain],
    (main) => main.modalDiagramQuickShareData
);

// MODAL DIAGRAM CREATE NEW
export const selectIsModalDiagramCreateNewEnabled = createSelector(
    [selectMain],
    (main) => main.isModalDiagramCreateNewEnabled
);

// MODAL LANGUAGES
export const selectIsModalLanguagesEnabled = createSelector(
    [selectMain],
    (main) => main.isModalLanguagesEnabled
);
export const selectLanguage = createSelector(
    [selectMain],
    (main) => main.lang
);
